/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const StarCircled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Star circled 24">
      <path
        fill="#0E0E0E"
        d="M11.35 6.418a.75.75 0 0 1 1.345 0l1.357 2.75a.75.75 0 0 0 .564.41l3.035.441a.75.75 0 0 1 .416 1.28l-2.196 2.14a.75.75 0 0 0-.216.664l.519 3.022a.75.75 0 0 1-1.089.79l-2.714-1.426a.75.75 0 0 0-.698 0l-2.714 1.427a.75.75 0 0 1-1.088-.79l.518-3.023a.75.75 0 0 0-.216-.664l-2.196-2.14a.75.75 0 0 1 .416-1.28l3.035-.44a.75.75 0 0 0 .564-.411l1.357-2.75Z"
        className="SVG"
      />
      <circle
        cx={12}
        cy={12}
        r={11}
        stroke="#0E0E0E"
        strokeWidth={2}
        className="Ellipse 731"
      />
    </g>
  </svg>
);

export const StarCircledIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'star-circled-icon'}
      icon={StarCircled}
      {...props}
      size={size}
    />
  );
};
